"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.585 6.366c1.018-.78 2.488-.054 2.488 1.228v8.859H20.3a.7.7 0 1 1 0 1.4h-4.087a.7.7 0 0 1-.002-1.4l1.462-.001V7.594a.147.147 0 0 0-.236-.117l-.776.595a.7.7 0 0 1-.852-1.112zm-8.018 1.11a.14.14 0 0 0-.053.068L5.64 14.428h6.01L8.784 7.544a.14.14 0 0 0-.053-.069.16.16 0 0 0-.083-.022.16.16 0 0 0-.082.022m4.755 7.328-3.244-7.798c-.529-1.27-2.326-1.27-2.856-.002L3.976 14.78a.7.7 0 0 0-.068.162l-.854 2.045a.7.7 0 0 0 1.292.54l.709-1.698h7.177l.706 1.697a.7.7 0 1 0 1.292-.538l-.862-2.072a1 1 0 0 0-.046-.11",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AlphaNumericIcon24.js.map